import Table from 'react-bootstrap/Table'
import React, {useState} from 'react'
import Navbar from '../components/Notice/Navbar'
import Sidebar from '../components/Console/Sidebar'
// import {useTable} from 'react-table'
import '../App.css'
import ConsoleFooter from '../components/Console/Footer'
import {useTranslation} from "react-i18next"
import { Link } from 'react-router-dom';

function Text1( ) {
  const {t} =useTranslation();
  const [isOpen, setIsOpen] = useState(false)

	const toggle = () => {
		setIsOpen(!isOpen)
	}
  // const {t} = useTranslation();
  // const [userList, setUserList] = useState([]);
  // const columns = [
  //   {dataField: "id", text:"Id"},
  //   {dataField: "name", text:"Name"},
  //   {dataField: "email", text:"Email"}
  // ]

  // useEffect(() => {
  //   fetch("https://jsonplaceholder.typicode.com/users")
  //   .then(response => response.json())
  //   .then(result => setUserList(result))
  //   .catch(error => console.log(error));
  // }, [])
  // useTable({
  //   columns: columns,
  //   data: userList
  // })
  return (
    <div>
      <Sidebar isOpen= {isOpen} toggle={toggle}/>
		  <Navbar />
      <div style={{height:"800px", textAlign:"-webkit-center", marginTop:"150px"}}>
        <div style={{position:"relative", marginBottom:"50px"}}>
          <h1 style={{color:"#2783C6"}}>{t("issue")}</h1>
          <Table hover>
            <thead>
              <span style={{color:"black", float:"left", fontWeight:"500"}}>[사용자, 관리자] 홈페이지 오픈</span>
              <span style={{color:"black", float: "right", fontWeight:"500"}}>2021-12-28</span>
            </thead>
            <tbody>
              <br/>
              
              <div>
              <span style={{font:" normal  300 15px 'Spoqa Han Sans Neo'"}}>
              <p style={{fontSize:"17px"}}>안녕하세요 쉐어플러그 운영팀입니다. </p>
       
                <p>2021년 12월 28일 쉐어플러그 홈페이지가 오픈되었습니다</p>
         
                
                <p style={{fontSize:"17px"}}>홈페이지는 사용자 위주의 정보를 먼저 확인하실 수 있으며, 클릭을 통해서 관리자 정보도 확인하실 수 있습니다. </p>
                 
                <p style={{fontSize:"17px"}}>각 관리자 Admin 로그인 및 사용자 페이지는 순차적으로 오픈될 예정입니다. </p>
                   
                
               <p style={{fontSize:"17px"}}>많은 기대 부탁드리겠습니다. </p><br/>

              </span>
              
              
              </div>
            </tbody>
            <tfoot>

              <td><b></b></td>
              <td colSpan="5"></td>
              <td></td>

            </tfoot>
          </Table>
          <div>
          <button className='noticeTextButton'><Link to="/notice" style={{textDecoration:"none"}}>{t("notice.btn")}</Link> </button>

          </div>
        </div>
      </div>
      <ConsoleFooter />
    </div>
  )
}

export default Text1
